module.exports = __webpack_public_path__ + "img/againbut.eb2e3c44.png";